export enum AcademicBackground {
  BACHELOR = 'BACHELOR',
  TECHNICAL = 'TECHNICAL',
  UNDERGRADUATE ='UNDERGRADUATE',
  MASTER_DEGREE = 'MASTER_DEGREE',
  PHD = 'PHD',
  ANY = 'ANY'
};
